import React, { useState } from 'react';
import styled from 'styled-components';
import { ThemeProvider } from 'styled-components';
import { AnniversaryProvider } from '../context/AnniversaryContext';
import theme from '../styles/theme';
import GlobalStyles from '../styles/GlobalStyles';
import Navigation from '../components/layout/Navigation';
import CollagePhotoGallery from './comix-inspo/CollagePhotoGallery';

const OurMemories: React.FC = () => {
  const [isLightboxOpen, setIsLightboxOpen] = useState(false);

  const handleLightboxChange = (isOpen: boolean) => {
    setIsLightboxOpen(isOpen);
  };

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <AnniversaryProvider>
        <AppContainer>
          <Navigation isLightboxOpen={isLightboxOpen} />
          <main>
            <CollagePhotoGallery onLightboxChange={handleLightboxChange} />
          </main>
        </AppContainer>
      </AnniversaryProvider>
    </ThemeProvider>
  );
};

const AppContainer = styled.div`
  width: 100%;
  overflow-x: hidden;
  background-color: ${({ theme }) => theme.colors.background};
  min-height: 100vh;
`;

export default OurMemories; 